import { gql, useQuery } from "@apollo/client";
import { ErrorComponent } from "@src/components";
import Summary from "@src/components/summary/Summary";
import { type GQLUserSummaryAdminQuery, type GQLUserSummaryAdminQueryVariables } from "@src/graphql.generated";
import CameraWithLicence from "@src/icons/CameraWithLicence";
import CameraWithoutLicence from "@src/icons/CameraWithoutLicence";
import UserWithLicence from "@src/icons/UserWithLicence";
import UserWithoutLicence from "@src/icons/UserWithoutLicence";
import { type FC, type PropsWithChildren } from "react";
import { FormattedMessage } from "react-intl";

const userSummaryAdminQuery = gql`
    query UserSummaryAdmin {
        userSummaryAdmin {
            usersWithLicencesCount
            usersWithoutLicencesCount
            userCamerasWithLicencesCount
            userCamerasWithoutLicencesCount
        }
    }
`;

const UsersSummary: FC<PropsWithChildren> = () => {
    const { data, error } = useQuery<GQLUserSummaryAdminQuery, GQLUserSummaryAdminQueryVariables>(userSummaryAdminQuery);

    const summaryItems = [
        {
            count: data?.userSummaryAdmin.usersWithLicencesCount,
            text: <FormattedMessage id="reviermanager.page.users.summary.usersWithLicence" defaultMessage="Kunden mit Lizenz" />,
            icon: <UserWithLicence fontSize="large" color="primary" />,
        },
        {
            count: data?.userSummaryAdmin.usersWithoutLicencesCount,
            text: <FormattedMessage id="reviermanager.page.devices.summary.usersWithoutLicence" defaultMessage="Kunden ohne Lizenz" />,
            icon: <UserWithoutLicence fontSize="large" color="primary" />,
        },
        {
            count: data?.userSummaryAdmin.userCamerasWithLicencesCount,
            text: <FormattedMessage id="reviermanager.page.devices.summary.camerasWithLicence" defaultMessage="Kameras mit Lizenz" />,
            icon: <CameraWithLicence fontSize="large" color="primary" />,
        },
        {
            count: data?.userSummaryAdmin.userCamerasWithoutLicencesCount,
            text: <FormattedMessage id="reviermanager.page.devices.summary.camerasWithoutLicence" defaultMessage="Kameras ohne Lizenz" />,
            icon: <CameraWithoutLicence fontSize="large" color="primary" />,
        },
    ];

    if (error) {
        return <ErrorComponent />;
    }

    return <Summary items={summaryItems} />;
};

export default UsersSummary;
